import { render, staticRenderFns } from "./MainSidebar.vue?vue&type=template&id=a6de0f40&"
import script from "./MainSidebar.vue?vue&type=script&lang=ts&"
export * from "./MainSidebar.vue?vue&type=script&lang=ts&"
import style0 from "./MainSidebar.vue?vue&type=style&index=0&id=a6de0f40&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports